import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import { getIPv6Prefix } from "common/api";
import LoadList from "./ListSubscribers";
import ActionsContext from "common/ActionsContext";
import BqnContext from "common/BqnContext";
import { subscribersRetrieval } from "../api";

const ensureCIDR = (subnet) =>
  Promise.resolve(
    subnet.length === 0 || subnet.includes("/") ? subnet : addCIDR(subnet)
  );

const addCIDR = (subnet) =>
  subnet.includes(":")
    ? /*ipv6*/ getIPv6Prefix().then((prefix) => `${subnet}/${prefix}`)
    : `${subnet}/32`;

const doRequest = ({ policy, subnet, lines, mode, bqnId }) =>
  ensureCIDR(subnet).then((cidrSubnet) =>
    subscribersRetrieval({
      policy,
      subnet: cidrSubnet,
      lines,
      mode,
      bqnId,
    }).then(response => ({response}))
  );

const ResultsLayout = styled.div`
  flex: 100%;
  overflow: hidden; /*list will scroll*/
`;

const Report = ({ policy, subnet, lines, ...otherSettings }) => {
  const [request, setRequest] = useState(null);
  const actions = useContext(ActionsContext);
  const { bqnId, clusterStatus } = useContext(BqnContext);
  const mode = clusterStatus?.mode;
  const doLoad = () =>
    setRequest(doRequest({ policy, subnet, lines, mode, bqnId }));
  // Nothing is asked while the BQN context has not loaded the BQN selected:
  // the command would not carry its option, and the response would be that of
  // the whole cluster. The effect runs again when it does.
  useEffect(() => {
    if (bqnId === undefined) {
      return;
    }

    doLoad();
    return actions.recv("do-load", doLoad);
  }, [policy, subnet, lines, mode, bqnId]);
  return request === null ? null : (
    <>
      <ResultsLayout>
        <LoadList request={request} subnet={subnet} {...otherSettings} />
      </ResultsLayout>
    </>
  );
};

export default Report;
